export default {
      id: "copy-settings-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#copy-settings-usage",
      toString: function () {
        return this.url;
      }
    }